import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxPeriod from '../util/remote/ajaxPeriod';
import functions from '../util/functions';
import ajaxReport from '../util/remote/ajaxReport';

const initialState = { 
    weeklyIncomeGraph: null,
    monthlyIncomeGraph: null,
    financialPeriods: null,
    selectedYear: null,
    trialBalance: null,
    trialBalanceProjectReport: null,
    incomeStatementProjectReport: null,
    balanceSheetProjectReport: null,
    TBDetailLevel: 0,
    ISDetailLevel: 0,
    BSDetailLevel: 0,
    mounted: false,
    ISMounted: false,
    BSMounted: false,
    dateRange: { opening_date: "", closing_date: "" }
};

const reducer = (state, action) => {

  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
  }

};


const ProjectReportContext = createContext();

export const ProjectReportProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(()=>{
    if(state.mounted){
      getTrialBalanceProjectReport(true)
    }
  }, [state.TBDetailLevel])

  useEffect(()=>{
    if(state.ISMounted){
      getIncomeStatementProjectReport(true)
    }
  }, [state.ISDetailLevel])

  useEffect(()=>{
    if(state.BSMounted){
      getBalanceSheetProjectReport(true)
    }
  }, [state.BSDetailLevel])
  
  const getWeeklyIncomeGraph = async () => {
    const server_response  = await ajaxReport.fetchWeeklyIncomeGraph([]);
    if(server_response.status === "OK"){
        dispatch({ type: 'weeklyIncomeGraph', payload: server_response.details });
    }
  };

  const getMonthlyIncomeGraph = async () => {
    const server_response  = await ajaxReport.fetchMonthlyIncomeGraph([]);
    if(server_response.status === "OK"){
        dispatch({ type: 'monthlyIncomeGraph', payload: server_response.details });
    }
  };

  const refresh = async() =>{
    await getWeeklyIncomeGraph();
    await getMonthlyIncomeGraph();
  }

  const getFinancialPeriods = async () => {
    const server_response = await ajaxPeriod.listPeriods();
    if(server_response.status === "OK"){
      dispatch({ type: 'financialPeriods', payload: server_response.details });
    }else{
      dispatch({ type: 'financialPeriods', payload: '404' });
    }
  }

  const getTrialBalance = async () => {
    const server_response = await ajaxReport.getTrialBalance();
    if(server_response.status === "OK"){
      dispatch({ type: 'trialBalance', payload: server_response.details });
    }else{
      dispatch({ type: 'trialBalance', payload: '404' });
    }
  }

  const getTrialBalanceProjectReport = async (refresh = false, period = null) => {
    dispatch({ type: 'mounted', payload: true });
    if(!refresh && functions.isObject(state.trialBalanceProjectReport)){
      return;
    }

    if(refresh){
      dispatch({ type: 'trialBalanceProjectReport', payload: null });
    }
    const server_response = await ajaxReport.fetchTrialBalanceReport({
      level: state.TBDetailLevel,
      opening_date: period?.opening_date || state.dateRange?.opening_date,
      closing_date: period?.closing_date || state.dateRange?.closing_date
    });
    if(server_response.status === "OK"){
      dispatch({ type: 'trialBalanceProjectReport', payload: server_response.details });
    }else{
      dispatch({ type: 'trialBalanceProjectReport', payload: '404' });
    }
  }


  const getIncomeStatementProjectReport = async (refresh = false, period = null, tag_id) => {
    dispatch({ type: 'ISMounted', payload: true });
    if(!refresh && functions.isObject(state.incomeStatementProjectReport)){
      return;
    }

    if(refresh){
      dispatch({ type: 'incomeStatementProjectReport', payload: null });
    }
    const server_response = await ajaxReport.fetchIncomeStatementReport({
      level: state.ISDetailLevel,
      opening_date: period?.opening_date || state.dateRange?.opening_date,
      closing_date: period?.closing_date || state.dateRange?.closing_date,
      tag_id
    });
    if(server_response.status === "OK"){
      dispatch({ type: 'incomeStatementProjectReport', payload: server_response.details });
    }else{
      dispatch({ type: 'incomeStatementProjectReport', payload: '404' });
    }
  }


  const getBalanceSheetProjectReport = async (refresh = false, period = null) => {
    dispatch({ type: 'BSMounted', payload: true });
    if(!refresh && functions.isObject(state.balanceSheetProjectReport)){
      return;
    }

    if(refresh){
      dispatch({ type: 'balanceSheetProjectReport', payload: null });
    }
    const server_response = await ajaxReport.fetchBalanceSheetReport({
      level: state.BSDetailLevel,
      opening_date: period?.opening_date || state.dateRange?.opening_date,
      closing_date: period?.closing_date || state.dateRange?.closing_date
    });
    if(server_response.status === "OK"){
      dispatch({ type: 'balanceSheetProjectReport', payload: server_response.details });
    }else{
      dispatch({ type: 'balanceSheetProjectReport', payload: '404' });
    }
  }


  
  return(
    <ProjectReportContext.Provider value={{
      ...state, 
      dispatch, 
      getMonthlyIncomeGraph,
      getWeeklyIncomeGraph,
      getFinancialPeriods,
      getTrialBalance,
      refresh,
      getTrialBalanceProjectReport,
      getIncomeStatementProjectReport,
      getBalanceSheetProjectReport
      }}>
      {children}
    </ProjectReportContext.Provider>
  )

}

export const useProjectReport = ()=>useContext(ProjectReportContext);

